import { constants } from "./definitions";

const determineErrorMessage = (
  error: string | Error | unknown,
  fallbackError?: string
): string => {
  if (typeof error === "string") {
    return error;
  } else if (error instanceof Error) {
    return error.message;
  } else {
    return fallbackError || constants.DEFAULT_UNKNOWN_ERROR;
  }
};

export default { determineErrorMessage };
